import request from '@/utils/request'

// 小区月卡价格配置
// 说明：后端接口使用白名单方式注册（carMonth.*），
// 不依赖 c_service / c_route 配置，返回结构为 { total, records, cardConfigs: [] }

// 查询小区月卡配置列表
export function listCarMonthCardConfigs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/carMonth.listCarMonthCardConfigs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.cardConfigs || [],
          total: res.total || 0
        })
      } else {
        reject(new Error(res.msg || '查询月卡配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增小区月卡配置
export function saveCarMonthCardConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/carMonth.saveCarMonthCardConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增月卡配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改小区月卡配置
export function updateCarMonthCardConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/carMonth.updateCarMonthCardConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改月卡配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除小区月卡配置
export function deleteCarMonthCardConfig(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/carMonth.deleteCarMonthCardConfig',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除月卡配置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
